<!--
 * @Author:
 * @Description:步骤1-验证你的业务
 * @Date: 2024-09-09 14:11:44
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/views/register/networkApplication/components/step-websiteOrApplication.vue
-->
<template>
  <div class="step_websiteOrApplication" v-loading="loading">
    <div>
      <p class="descript1"> {{ $t('message.register.validateBusiness.websiteOrApplication.descript1') }}</p>
      <p class="descript2">{{ $t('message.register.validateBusiness.websiteOrApplication.descript2') }}</p>
    </div>
    <validation-component ref="validationForm" :validation-condition="validationCondition">
      <div slot="transactionStatementsLastThreeMonths">
        <template>
          <RhcnUpload :title="$t('message.register.websiteOrApplication_desc.Transaction statements (last 3 months)')"
            :fileList="form.uploadBusinessProofs.fileList.transactionStatementsLastThreeMonths"
            :on-change="onMaterialItemChange('form', 'uploadBusinessProofs', 'transactionStatementsLastThreeMonths')"
            :on-remove="onMaterialItemRemove('form', 'uploadBusinessProofs', 'transactionStatementsLastThreeMonths')"
            :disabled="isDisabled">
          </RhcnUpload>
        </template>
      </div>
      <div slot="screenshotsOfBusinessPlatforms">
        <template>
          <RhcnUpload :title="$t('message.register.websiteOrApplication_desc.Screenshots of business platforms')"
            :fileList="form.uploadBusinessProofs.fileList.screenshotsOfBusinessPlatforms"
            :on-change="onMaterialItemChange('form', 'uploadBusinessProofs', 'screenshotsOfBusinessPlatforms')"
            :on-remove="onMaterialItemRemove('form', 'uploadBusinessProofs', 'screenshotsOfBusinessPlatforms')"
            :disabled="isDisabled">
          </RhcnUpload>
        </template>
      </div>

    </validation-component>
    <div class="button-box">
      <el-button type="primary" @click="confirm" size="mini" :disabled="isDisabled">{{ $t('message.exchange.continue')
        }}</el-button>
    </div>

  </div>
</template>

<script>
import { getDictionary } from '@/api/common/index';
import { REQUIRED } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import { DurationOfOperationList, marketOptions, monthlyTradingVolumeUsdOptions, monthlyDisputeRateOptions, monthlyRefundRateOptions } from '@/utils/options/networkApplication';
import { transformDictionaryToOptions } from '@/utils/tools/constant';
import RhcnUpload from '@/views/account/information/supplement/upload/index.vue';

import mixins from '../../mixins';
export default {
  name: 'StepWebsiteOrApplication',
  components: {
    ValidationComponent,
    RhcnUpload,
  },
  mixins: [mixins],
  data() {
    return {
      form: {
        uploadBusinessProofs: {
          transactionStatementsLastThreeMonths: '',
          screenshotsOfBusinessPlatforms: '',
          fileList: {
            transactionStatementsLastThreeMonths: [],
            screenshotsOfBusinessPlatforms: [],
          },
        },
      },
      validationCondition: [
        {
          key: 'businessWebsite', // 业务网站
          name: 'message.register.websiteOrApplication_desc.business_website',
          type: 'input',
          placeholder: 'www.example.com',
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
          defValue: '',
        },
        {
          key: 'durationOfOperation', // 已运营时间
          name: 'message.register.websiteOrApplication_desc.duration_of_operation',
          type: 'select',
          isInternationalization: true,
          options: DurationOfOperationList,
          isShowStar: true,
          rule: [REQUIRED],
          defValue: '',
        },
        {
          key: 'businessWebsiteType', // 网站类型
          name: 'message.register.websiteOrApplication_desc.business_website_type',
          type: 'select',
          isInternationalization: true,
          options: this.websiteTypeList,
          isShowStar: true,
          changeValue: this.businessWebsiteTypeChangeValue,
          rule: [REQUIRED],
          defValue: '',
        },
        {
          key: 'websiteDefaultDomain', // 原始网址
          name: 'message.register.websiteOrApplication_desc.website_default_domain',
          placeholder: 'message.register.websiteOrApplication_desc.placeholder.website_default_domain',
          type: 'input',
          isInternationalization: true,
          isShowStar: true,
          rule: [],
        },
        {
          key: 'industryOrBusinessCategory', // 所属行业
          name: 'message.register.websiteOrApplication_desc.industry/Business_category',
          type: 'select',
          placeholder: 'message.register.websiteOrApplication_desc.placeholder.industry/Business_category',
          options: [],
          group: true,
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
          defValue: '',
        },
        {
          key: 'monthlyTradingVolumeUsd', // 月交易额（USD）
          name: 'message.register.websiteOrApplication_desc.monthly_trading_volume (USD)',
          type: 'select',
          options: monthlyTradingVolumeUsdOptions,
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
          defValue: '',
        },
        {
          key: 'monthlyDisputeRate', // 月拒付率
          name: 'message.register.websiteOrApplication_desc.monthly_dispute_rate',
          type: 'select',
          options: monthlyDisputeRateOptions,
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
        },
        {
          key: 'monthlyRefundRate', // 月退款率
          name: 'message.register.websiteOrApplication_desc.monthly_refund_rate',
          type: 'select',
          options: monthlyRefundRateOptions,
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
          defValue: '',
        },
        {
          key: 'market', // 业务面向市场
          name: 'message.register.websiteOrApplication_desc.market',
          type: 'select',
          group: true,
          multiple: true,
          multipleLimit: 3,
          width: '450px',
          options: marketOptions,
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
          defValue: '',
        },
        {
          key: 'businessRegistrationCertificate', // 公司营业登记证书
          name: 'message.register.websiteOrApplication_desc.upload_business_proofs',
          type: 'slot',
          isInternationalization: true,
          isShowStar: true,
        },
        {
          key: 'transactionStatementsLastThreeMonths', // 交易报表（近三月）
          type: 'slot',
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
        },
        {
          key: 'screenshotsOfBusinessPlatforms', // 业务平台截图
          type: 'slot',
          isInternationalization: true,
          isShowStar: true,
        },
        // {
        //   key: 'uploadBusinessProofs',
        //   name: 'message.register.websiteOrApplication_desc.upload_business_proofs',
        //   type: 'upload_fixed_image',
        //   defValue: '',
        //   isShowStar: true,
        //   uploadRange: [
        //     {
        //       uploadFileList: [],
        //       fileSize: 10,
        //       limit: 1,
        //       isFile: false,
        //       fileTypeRule: 'image/png,image/jpg,image/jpeg',
        //       fileTypeRuleTips: 'message.payee.payeeFileTip',
        //       fileLongDisplayTips: 'message.register.websiteOrApplication_desc.Transaction statements (last 3 months)',
        //     },
        //     {
        //       uploadFileList: [],
        //       fileSize: 10,
        //       limit: 1,
        //       isFile: false,
        //       fileTypeRule: 'image/png,image/jpg,image/jpeg',
        //       fileTypeRuleTips: 'message.payee.payeeFileTip',
        //       fileLongDisplayTips: 'message.register.websiteOrApplication_desc.Screenshots of business platforms',
        //     },

        //   ],
        // },
      ],
    };
  },
  created() {
    getDictionary(['WEB_TYPE', 'MCC']).then((res) => {
      const websiteTypeList = transformDictionaryToOptions(res.WEB_TYPE);
      let _websiteTypeList = [];
      if (websiteTypeList && websiteTypeList.length > 0) {
        _websiteTypeList = websiteTypeList.filter(item => ['WEB01', 'WEB02', 'WEB03', 'WEB04', 'WEB05', 'WEB06', 'WEB07', 'WEB08'].includes(item.value));
      }

      const MCCList = transformDictionaryToOptions(res.MCC);
      this.validationCondition.find(item => item.key === 'businessWebsiteType').options = _websiteTypeList;
      this.validationCondition.find(item => item.key === 'industryOrBusinessCategory').options = MCCList;

      const hotArr = ['5817', '5732', '5691'];
      const hotOptions = MCCList.filter(item => hotArr.includes(item.value)).map(item => {
        return {
          label: `${item.value}-${item.label}`,
          value: item.value,
        };
      });
      const otherOptions = MCCList.filter(item => !hotArr.includes(item.value)).map(item => {
        return {
          label: `${item.value}-${item.label}`,
          value: item.value,
        };
      });
      const options = [
        {
          label: 'message.register.marketOptions.hottest',
          options: [...hotOptions],
        },
        {
          label: 'message.register.marketOptions.otherMarket',
          options: [...otherOptions],
        },
      ];
      this.validationCondition.find(item => item.key === 'industryOrBusinessCategory').options = options;
    }).catch(() => ({}));
  },
  methods: {
    businessWebsiteTypeChangeValue(businessWebsiteType) {
      console.log(businessWebsiteType, 'businessWebsiteType');
      if (businessWebsiteType === 'WEB02') {
        this.$refs.validationForm.updateItemRule('websiteDefaultDomain', [REQUIRED]);
      } else {
        this.$refs.validationForm.updateItemRule('websiteDefaultDomain', []);
      }
    },
    confirm() {
      this.$refs.validationForm.toFormValid(params => {
        const {
          transactionStatementsLastThreeMonths,
          screenshotsOfBusinessPlatforms,
        } = this.form.uploadBusinessProofs;
        const {
          businessWebsite,
          durationOfOperation, businessWebsiteType, websiteDefaultDomain, industryOrBusinessCategory, monthlyTradingVolumeUsd, monthlyDisputeRate, monthlyRefundRate, market,
        } = params;
        console.log(market, 'market');

        // 判断market 是否是数组，如果是数组转化为字符串
        const _market = Array.isArray(market) ? market.join(',') : market;
        const websiteOrAppDetails = {
          businessWebsite,
          durationOfOperation,
          businessWebsiteType,
          websiteDefaultDomain,
          industryOrBusinessCategory,
          monthlyTradingVolumeUsd,
          monthlyDisputeRate,
          monthlyRefundRate,
          market: _market,
          uploadBusinessProofs: {
            transactionStatementsLastThreeMonths,
            screenshotsOfBusinessPlatforms,
          },
        };
        this.$emit('updateFormData', { websiteOrAppDetails, currentStep: 'websiteOrAppDetails', nextStep: 'bankAccount' });
      });
    },
  },
  watch: {
    applicationInfo: {
      handler(applicationInfo) {
        const { websiteOrAppDetails, websiteOrAppDetails: { uploadBusinessProofs }, currentStep } = applicationInfo;
        const _data = { ...websiteOrAppDetails, ...uploadBusinessProofs, market: websiteOrAppDetails.market.split(',') };
        const isDisabled = currentStep === 'status';
        if (isDisabled) {
          this.$refs.validationForm.setItemDisabled('', true, true);
        }
        if (_data.businessWebsite) {
          ['businessWebsite',
            'durationOfOperation',
            'businessWebsiteType',
            'websiteDefaultDomain',
            'industryOrBusinessCategory',
            'monthlyTradingVolumeUsd',
            'monthlyDisputeRate',
            'monthlyRefundRate',
            'market',
            'transactionStatementsLastThreeMonths',
            'screenshotsOfBusinessPlatforms',
          ].forEach(key => {
            this.$refs.validationForm.setItemValue(key, _data[key]);
          });
          const arr = [
            'transactionStatementsLastThreeMonths',
            'screenshotsOfBusinessPlatforms',
          ];
          arr.forEach(item => {
            this.form.uploadBusinessProofs[item] = _data[item];
            _data[item] && this.form.uploadBusinessProofs.fileList[item].push({
              url: _data[item],
              name: '',
            });
          });
          this.$nextTick(() => {
            this.$refs.validationForm.toFormValid((params) => {
              // this.$emit('onlyUpdateForm', { websiteOrAppDetails, currentStep: 'websiteOrAppDetails' });
              const {
                transactionStatementsLastThreeMonths,
                screenshotsOfBusinessPlatforms,
              } = this.form.uploadBusinessProofs;
              const {
                businessWebsite,
                durationOfOperation, businessWebsiteType, websiteDefaultDomain, industryOrBusinessCategory, monthlyTradingVolumeUsd, monthlyDisputeRate, monthlyRefundRate, market,
              } = params;
              // 判断market 是否是数组，如果是数组转化为字符串
              const _market = Array.isArray(market) ? market.join(',') : market;
              const websiteOrAppDetails = {
                businessWebsite,
                durationOfOperation,
                businessWebsiteType,
                websiteDefaultDomain,
                industryOrBusinessCategory,
                monthlyTradingVolumeUsd,
                monthlyDisputeRate,
                monthlyRefundRate,
                market: _market,
                uploadBusinessProofs: {
                  transactionStatementsLastThreeMonths,
                  screenshotsOfBusinessPlatforms,
                },
              };
              this.$emit('onlyUpdateForm', { websiteOrAppDetails, currentStep: 'websiteOrAppDetails' });
            });
          });
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/index.scss';

.el-select-group__title {
  color: $--color-text-primary;
  padding-left: 0;
}

.button-box {
  width: 100%;

  .el-button {
    width: 100% !important;
  }
}

.el-scrollbar {
  max-width: 450px !important;
}
</style>
